import { HTMLAttributes } from 'react';

interface CatalogGridProps extends HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode,
}

export function CatalogGrid({ children, ...props }: CatalogGridProps) {
    return (
        <div className="catalog-grid" {...props}>
            {children}
        </div>
    );
}
